import React from 'react';

const CloudCertificationTraining = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          Cloud (AWS, Azure, GCP) Certification Training
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            Get certified on leading cloud platforms with our expert-led training programs for AWS, Azure, and Google Cloud. We offer comprehensive courses, hands-on labs, and exam preparation to help you achieve your cloud career goals.
          </p>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>AWS, Azure, and GCP certification tracks</li>
            <li>Practical labs and real-world scenarios</li>
            <li>Exam strategies and tips</li>
            <li>Corporate and individual training options</li>
          </ul>
          <p className="text-gray-700">
            Unlock new opportunities with cloud certifications.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default CloudCertificationTraining;
